import { SurveyDTO, SurveyResponsesDTO } from "@teams/types/api";
import React from "react";

import { TriviaLeaderboard } from "../../components/trivia/TriviaLeaderboard";
import { HotTakeInformation } from "./hotTake/HotTakeInformation";
import { IcebreakerInformation } from "./icebreaker/IcebreakerInformation";
import { QnaResultsDetails } from "./qna/QnaResultsDetails";
import { QuizResultsDetails } from "./quiz/QuizResultsDetails";
import { SurveyResultsList } from "./SurveyResultsList";

export const SurveyDetailsPage: React.FC<{ survey: SurveyDTO; results: SurveyResponsesDTO }> = ({
  survey,
  results,
}) => {
  switch (survey.type) {
    case "quiz":
      return <QuizResultsDetails survey={survey} results={results} showPostResultsAction />;
    case "trivia":
      return <TriviaLeaderboard survey={survey} />;
    case "qna":
      return <QnaResultsDetails surveyId={survey.id as string} />;
    case "icebreaker":
      return <IcebreakerInformation surveyId={survey.id as string} />;
    case "hot-take":
      return <HotTakeInformation surveyId={survey.id as string} answerForm />;
    default:
      return <SurveyResultsList survey={survey} results={results} />;
  }
};
